import styled from "styled-components";

export const ContainerSidebar = styled.aside`
  background: var(--field-color);
  border-radius: var(--border-radius-1);
  box-shadow: var(--box-shadow2);
  padding: 2em 0;
  height: fit-content;
  .active-link {
    position: relative;
    font-weight: bold;
  }
  .active-link:after {
    content: "";
    width: 30px;
    height: 20px;
    position: absolute;
    left: -5px;
    border-radius: 40px 40px 0 0;
    background: #ffffff;
    box-shadow: 1px 1px 20px #fefefe;
    transform: rotate(90deg);
  }
`;
